// extracted by mini-css-extract-plugin
export default {"savedFilters":"SavedFilters__savedFilters___hD_WT","savedFiltersBtn":"SavedFilters__savedFiltersBtn___wN9dk"};